var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'd-flex title-widget text-h5 text-md-h3 font-weight-medium primary--text text--darken-1',
    _vm.className,
    !_vm.small ? 'text-h5 text-md-h3' : 'text-h6 text-sm-h5 text-md-h4' ]},[_c('span',{staticClass:"font-bazinga"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }